// extracted by mini-css-extract-plugin
export default {"root":"BKPCa","buttonWrapper":"sSTgw","text":"aPhSv"};